module.exports = __webpack_public_path__ + "img/exlDownload.1bc18f2e.svg";